import { observer } from 'mobx-react-lite';
import { Suspense, SyntheticEvent, useEffect, useState } from 'react';
import {
  Card,
  Grid,
  Button,
  Header,
  Form,
  Input,
  Icon,
  Segment,
} from 'semantic-ui-react';
import { v4 as uuid } from 'uuid';
import { useStore } from '../../../app/stores/store';
import WorkflowTypeElements from './WorkflowElementTypes';
import { AssetType } from '../../../app/models/template';
import {
  cardcolor,
  errorEmptyText,
  errorMessageText,
  selectionEmptyErrorMsg,
} from '../../../app/common/form/errorMessageText';
import sendRespectiveEmail from '../../../app/models/EmailNew';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import UnauthorizedMessage from '../../UnauthorizedMessage';
import DeleteModal from '../../../library/deleteModal';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';

const cardStyleLevel5 = {
  display: 'inline-block',
  padding: '10px',
  height: '82vh',
  width: '200pt',
  marginLeft: '30px',
  marginTop: '5px',
  color: 'black',
  cursor: 'pointer',
  boxShadow: '5px 5px 10px lightgray',
  alignItems: 'center',
};
function WorkflowAssetType() {
  const {
    TemplateStore,
    workflowConfigurationStore,
    RolesAndPermissionsIDStore,
    userStore,
    dashboardStore,
    commonStore,
  } = useStore();
  const {
    assetTypesByName,
    loadAssetTypeById,
    createNewAssetType,
    assetTypeRegistry,
    loadAssetTypes,
    loadingInitialAT,
    selectedAssetType,
    editAssetType,
    deleteAssetType,
    cloneAssetType,
  } = TemplateStore;

  const [errorType, setErrorType] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [deleteOption, setDeleteOption] = useState<AssetType>({
    id: '',
    typeIndex: 0,
    typeName: '',
    isActive: false,
    isDeleted: false,
    elementTypes: [],
  });

  useEffect(() => {
    if (assetTypeRegistry.size <= 1) {
      setErrorType('');
      loadAssetTypes();
    }
  }, [assetTypeRegistry.size, loadAssetTypes]);

  useEffect(() => {
    workflowConfigurationStore.resetWorkflowConfigData();
    // eslint-disable-next-line
  }, []);

  const [newAssetType, setNewAssetType] = useState<string>(''); //onchage asset type name add new

  const handleClickAssetType = (id: string) => {
    if (
      workflowConfigurationStore.WorkflowConfiguration.disableClick === false
    ) {
      setErrorType('');
      loadAssetTypeById(id); // asset type load child inside
      workflowConfigurationStore.setShowAssetTypeName(id);

      workflowConfigurationStore.setShowElementTypesCard(true); // set elementtype  true
      workflowConfigurationStore.setAssetTypeIsActive(true); // set elementtype  true
      workflowConfigurationStore.setShowTemplateCard(false); // set template, task, subtask, element   false
      workflowConfigurationStore.setShowTaskCard(false); // set template, task, subtask, element   false
      workflowConfigurationStore.setShowSubTaskCard(false); // set template, task, subtask, element   false
      workflowConfigurationStore.setShowElementCard(false); // set template, task, subtask, element   false
    }
    //Edit Delete Should Also Be Cancelled
    workflowConfigurationStore.resetEditClickedButtonExceptAssetType();
  };
  const handleChangeName = (e: SyntheticEvent, data: any) => {
    setNewAssetType(data.value);
    const NameCheck = assetTypesByName.some(function (el) {
      function ciEquals(a: string, b: string) {
        return typeof a === 'string' && typeof b === 'string'
          ? a.trim().localeCompare(b.trim(), undefined, {
              sensitivity: 'accent',
            }) === 0
          : a.trim() === b.trim();
      }
      return ciEquals(el.typeName, data.value);
    });

    setErrorType(NameCheck ? 'SameName' : ''); //check name exists
  };
  ///////////this function to handle when Enter Key is pressed
  const handleKeyPress = (e: any) => {
    if (
      e.key === 'Enter' &&
      workflowConfigurationStore.WorkflowConfiguration.editClickedAssetype ===
        false
    ) {
      handleAddAssetType();
    }
    if (
      e.key === 'Enter' &&
      workflowConfigurationStore.WorkflowConfiguration.editClickedAssetype ===
        true
    ) {
      handleSaveEdited('edit');
    }
  };

  const handleAddAssetType = () => {
    if (errorType === '' && newAssetType.length !== 0) {
      const ID = uuid();
      const newArr = {
        id: ID,
        typeIndex:
          assetTypesByName.length === 0 ? 0 : assetTypesByName.length + 1,
        typeName: newAssetType,
        isActive: true,
        isDeleted: false,
        elementTypes: [],
      };
      const newRoleArr = {
        id: uuid(),
        itemId: ID,
        rolesId:
          userStore.user?.roleId !== undefined ? userStore.user?.roleId : '',
      };
      createNewAssetType(newArr);
      sendRespectiveEmail('create', newArr.typeName, 'Created Asset Type', ''); //email Function
      RolesAndPermissionsIDStore.createRoleID(newRoleArr);
      setNewAssetType(''); //set value to empty
    } else {
      setErrorType('EmptyName');
    }
  };
  const handleCloneData = () => {
    // cloning data
    if (selectedAssetType !== undefined && newAssetType.length > 0) {
      sendRespectiveEmail('cloned', newAssetType, 'Cloned Asset Type', ''); //email Function
      cloneAssetType(selectedAssetType.id, newAssetType);
    } else if (selectedAssetType === undefined) {
      setErrorType('selectionEmpty');
    } else if (newAssetType.length === 0) {
      setErrorType('EmptyName');
    }
    setNewAssetType('');
  };
  const handleEdit = (AssetType: AssetType) => {
    setErrorType('');
    loadAssetTypeById(AssetType.id);
    setNewAssetType(AssetType.typeName);
    workflowConfigurationStore.setEditClickedAssetType(true);
  };

  const handleSaveEdited = (type: string) => {
    if (
      selectedAssetType !== undefined &&
      type === 'edit' &&
      errorType === '' &&
      newAssetType.length !== 0
    ) {
      const AssetTypeArr = {
        ...selectedAssetType,
        typeName: newAssetType,
      };
      editAssetType(AssetTypeArr);
      sendRespectiveEmail(
        'edited',
        AssetTypeArr.typeName,
        'Edited Asset Type',
        '',
      ); //email Function
    }
    setNewAssetType('');
    workflowConfigurationStore.setEditClickedAssetType(false);
  };
  ///////////////////////////delete
  const HandleDelteAsset = (assetType: AssetType) => {
    setErrorType('');
    setDeleteOption(assetType);
    setIsModalOpen(true);
  };

  const deleteConfirmed = () => {
    const AssetTypeArr = {
      ...deleteOption,
      isDeleted: true,
    };
    deleteAssetType(AssetTypeArr);
    sendRespectiveEmail(
      'deleted',
      AssetTypeArr.typeName,
      'Deleted Asset Type',
      '',
    ); //email Function
    setIsModalOpen(false);
  };

  const AssetTypeJSX = (
    <Card className="workflow-config-assettypes">
      {assetTypesByName.map((assetType, index) => (
        <>
          <Card.Content
            key={index}
            onMouseEnter={() =>
              workflowConfigurationStore.setAssetTypeKey(index)
            }
            onMouseLeave={() =>
              workflowConfigurationStore.setAssetTypeKey(null)
            }
            style={
              assetType.id ===
              workflowConfigurationStore.WorkflowConfiguration.showassetTypeName
                ? cardcolor
                : null
            }
            onClick={() => handleClickAssetType(assetType.id)}
          >
            <Grid className="hoverColor" columns={3}>
              <Grid.Row columns={3}>
                <Grid.Column width={11}>{assetType.typeName}</Grid.Column>

                <Grid.Column
                  width={1}
                  onMouseEnter={() =>
                    workflowConfigurationStore.setDisableClick(true)
                  }
                  onMouseLeave={() =>
                    workflowConfigurationStore.setDisableClick(false)
                  }
                >
                  {workflowConfigurationStore.WorkflowConfiguration
                    .assetTypeKey === index ? (
                    <Icon
                      style={{ fontSize: '13px' }}
                      name="pencil"
                      color="grey"
                      size="small"
                      onClick={() => handleEdit(assetType)}
                    />
                  ) : null}
                </Grid.Column>
                <Grid.Column
                  width={1}
                  onMouseEnter={() =>
                    workflowConfigurationStore.setDisableClick(true)
                  }
                  onMouseLeave={() =>
                    workflowConfigurationStore.setDisableClick(false)
                  }
                >
                  {workflowConfigurationStore.WorkflowConfiguration
                    .assetTypeKey === index ? (
                    <Icon
                      style={{ fontSize: '13px' }}
                      name="trash"
                      color="grey"
                      size="small"
                      onClick={() => HandleDelteAsset(assetType)}
                    />
                  ) : null}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Card.Content>
        </>
      ))}
    </Card>
  );

  return (
    <>
      {isModalOpen && (
        <Suspense fallback={<></>}>
          <DeleteModal
            isModalOpen={isModalOpen}
            closeHandler={() => {
              setIsModalOpen(false);
            }}
            deleteHandler={deleteConfirmed}
            header={'Delete'}
            text={
              'Are you sure you want to delete this? Deleting it will also remove all related data.'
            }
          />
        </Suspense>
      )}
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <LoadingComponent />
      )}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !dashboardStore.dashboard.selectedUserRoleId.includes('SWLB01') && (
          <UnauthorizedMessage />
        )}
      {dashboardStore.dashboard.selectedUserRoleId.includes('SWLB01') && (
        <>
          <Header
            style={{ marginLeft: '20px' }}
            icon="cogs"
            size="huge"
            dividing
            as="h1"
            content={
              (userLanguage[0].Sidebar.M13I02 as any)?.[
                `${commonStore.language.key}`
              ]
            }
            sub
            color="grey"
          />
          <div
            style={{
              marginTop: '30px',
              marginRight: '10px',
              height: '85vh',
              marginLeft: '10px',
            }}
          >
            <Grid>
              <Card style={cardStyleLevel5}>
                <>
                  <Header
                    style={{ marginLeft: '20px' }}
                    size="huge"
                    as="h1"
                    content={
                      (userLanguage[0].SettingsWORKFLOW.SWL02 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    }  
                    sub
                    color="grey"
                  />
                  {!assetTypesByName || loadingInitialAT ? (
                    <LoadingComponent />
                  ) : (
                    AssetTypeJSX
                  )}
                </>
                <Segment className="workflow-bottom-card">
                  <Form>
                    <Form.Group widths="equal">
                      <Form.Field
                        id="form-input-control-error-email"
                        className=" workflow-input"
                        error={
                          errorType === 'SameName'
                            ? errorMessageText
                            : errorType === 'EmptyName'
                              ? errorEmptyText
                              : errorType === 'selectionEmpty'
                                ? selectionEmptyErrorMsg
                                : null
                        }
                        control={Input}
                        value={newAssetType}
                        placeholder={
                          (userLanguage[0].RPModal.RP03 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        }
                        onChange={handleChangeName}
                        onKeyDown={handleKeyPress}
                      />
                    </Form.Group>
                  </Form>
                  {workflowConfigurationStore.WorkflowConfiguration
                    .editClickedAssetype === false ? (
                    <div className="workflow-input-div">
                      {commonStore.filterModeTwo?.includes('SWB08') ? (
                        <></>
                      ) : (
                        <Button
                          primary
                          onClick={handleCloneData}
                          className="workflow-input-button"
                          disabled={
                            commonStore.filterModeZero?.includes('SWB08') ||
                            errorType !== ''
                          }
                        >
                          {
                            (userLanguage[0].RPModal.RP01 as any)?.[
                              `${commonStore.language.key}`
                            ]
                          }
                        </Button>
                      )}

                      {/* <Button
                            primary onClick={handleCloneData} className="workflow-input-button"
                            disabled={ !dashboardStore.dashboard.selectedUserRoleId.includes("SWB08") ? true : false || errorType === "SameName" || 
                            errorType === "EmptyName" ? true : false }>
                               Clone
                          </Button> */}

                      {commonStore.filterModeTwo?.includes('SWB06') ? (
                        <></>
                      ) : (
                        <Button
                          color="green"
                          floated="right"
                          onClick={handleAddAssetType}
                          className="workflow-input-button"
                          disabled={
                            commonStore.filterModeZero?.includes('SWB06') ||
                            errorType !== ''
                          }
                        >                         
                        {
                            (userLanguage[0].RPModal.RP02 as any)?.[
                              `${commonStore.language.key}`
                            ]
                          }
                        </Button>
                      )}

                      {/* <Button
                            color="green" floated="right" onClick={handleAddAssetType} className="workflow-input-button"
                            disabled={ !dashboardStore.dashboard.selectedUserRoleId.includes("SWB06") ? true : false ||
                             errorType === "SameName" || errorType === "EmptyName" ? true : false }
                            >
                                  Add New
                          </Button> */}
                    </div>
                  ) : (
                    <div className="workflow-input-div">
                      <Button
                        secondary
                        className="workflow-input-button"
                        onClick={() => handleSaveEdited('cancel')}
                      >
                        Cancel
                      </Button>
                      <Button
                        primary
                        floated="right"
                        onClick={() => handleSaveEdited('edit')}
                        className="workflow-input-button"
                        disabled={
                          errorType === 'SameName' || errorType === 'EmptyName'
                            ? true
                            : false
                        }
                      >
                        Save
                      </Button>
                    </div>
                  )}
                </Segment>
              </Card>
              {workflowConfigurationStore.WorkflowConfiguration
                .showElementTypesCard ? (
                <WorkflowTypeElements />
              ) : null}
            </Grid>
          </div>
        </>
      )}
    </>
  );
}
export default observer(WorkflowAssetType);